import { render, staticRenderFns } from "./mask.vue?vue&type=template&id=f74e522a&scoped=true"
import script from "./mask.vue?vue&type=script&lang=js"
export * from "./mask.vue?vue&type=script&lang=js"
import style0 from "./mask.vue?vue&type=style&index=0&id=f74e522a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74e522a",
  null
  
)

export default component.exports